import $ from 'jquery';
import 'owl.carousel';

import arrowprev from '../assets/images/arrow-down-square.svg';
import arrownext from '../assets/images/arrow-down-square2.svg';

$(window).on('load', function() {

    $('header .open-nav').on('click', function() {
        $('header .wrapper').addClass('open-menu');
    });

    $('header .close-nav').on('click', function() {
        $('header .wrapper').removeClass('open-menu');
    });

    $('.play-btn').on('click', function(e) {
        e.preventDefault();
        var link = $(this).attr('data-video');
        $('.modal-video').fadeIn(300).css('display', 'flex');
        $('.modal-video iframe').attr('src', link + '&autoplay=1');
        $('html, body').addClass('scroll-none');
    });
    $('.modal-video .cap-close, .modal-video .close-iframe').on('click', function() {
        $('.modal-video').fadeOut(0);
        $('.modal-video iframe').attr('src', '');
        $('html, body').removeClass('scroll-none');
    });

    $('.slider-home').owlCarousel({
        loop: true,
        nav: true,
        margin: 19,
        items: 3,
        smartSpeed: 2000,
        dotsSpeed: 2000,
        autoplay: false,
        autoplayTimeout: 5000,
        autoplayHoverPause: false,
        navText: [`<img src="${arrowprev}">`,`<img src="${arrownext}">`],
        responsive : {
            0 : {
                items: 1,
            },
            480 : {
                items: 1,
            },
            680: {
                items: 2,
            },
            1000 : {
                items: 3,
            }
        }
    });

    $('.tabs-content .top a').on('click', function(e) {
        e.preventDefault();
        var index = $('.tabs-content .top a').index( this );
        $(this).parent().addClass('active');
        $('.tabs-content .top a').not(this).parent().removeClass('active');
        $('.tabs-content .content .item').fadeOut(0);
        $('.tabs-content .content .item').eq(index).fadeIn(0);
    });

    $(function(){
        var lastScrollTop = 0, delta = 5;
        $(window).scroll(function(){
            var nowScrollTop = $(this).scrollTop();
            if(Math.abs(lastScrollTop - nowScrollTop) >= delta){
                if (nowScrollTop > lastScrollTop){
                    if(nowScrollTop > 10) {
                        $('header').addClass('scroll-header');
                    }
                } else {
                    if(nowScrollTop < 10) {
                        $('header').removeClass('scroll-header');
                    }
                }
            lastScrollTop = nowScrollTop;
            }
        });
    });

    $('.play-btn-audio').on('click', function(e){
        e.preventDefault();
        var $this = $(this);
        $this.toggleClass('active');
        var pause_img = $(this).attr('data-toggle');
        var play_img = $(this).attr('data-init');
        if($this.hasClass('active')){
            $('#sound')[0].play();
            $(this).find('img').attr('src',pause_img);
        } else {
            $('#sound')[0].pause();
            $(this).find('img').attr('src',play_img);
        }
    });

    function socialWindow(url) {
        var left = (screen.width - 570) / 2;
        var top = (screen.height - 570) / 2;
        var params = 'menubar=no,toolbar=no,status=no,width=570,height=570,top=' + top + ',left=' + left;

        window.open(url, 'NewWindow', params);
    }

    $('.social').on('click', '.facebook', function(e) {
        e.preventDefault();

        let url = 'https://www.facebook.com/sharer.php?u=' + $(this).attr('href');
        socialWindow(url);
    });

    $('.social').on('click', '.twitter', function(e) {
        e.preventDefault();

        let url = 'https://twitter.com/intent/tweet?url=' + $(this).attr('href');
        socialWindow(url);
    });

    $('.copy-href-to-clipboard').on('click', function (e) {
        e.preventDefault();

        var copyText = $(this).attr('href');
        document.addEventListener('copy', function(e) {
           e.clipboardData.setData('text/plain', copyText);
           e.preventDefault();
        }, true);
        var $this = $(this);
        $this.append( "<small>¡Copiado!</small>" );

        setTimeout(function() {
            $this.find("small").remove();
        },1500);
        document.execCommand('copy');
    });

    $('#pll-language').on('change', function(e) {
        location.href = $(this).val();
    });

});